import { render, staticRenderFns } from "./BajasCobranzaActions.vue?vue&type=template&id=27110cd2&"
import script from "./BajasCobranzaActions.vue?vue&type=script&lang=ts&"
export * from "./BajasCobranzaActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports